<template lang="html">
  <div class="privacy-page-wrap container">
  	<div class="row">
			<div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 white-box privacy-policy-information">
        <h1>Cookie- og privatlivspolitik på Odense Rundt</h1>
        <div id="privacy-policy-html" v-html="privacyPolicyHtml"></div>
			</div>

  	</div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      privacyPolicyHtml: false,
    }
  },
  created() {
    axios.get('https://apps.odenserundt.dk/data/odenserundt/texts/privacypolicy-dk.html')
    .then((response) => {
      this.privacyPolicyHtml = response.data;
    })
    .catch(function (error) {
      console.log(error);
    });

    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Privatlivspolitik - Odense Rundt');
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
  }
}
</script>

<style lang="css" scoped>
  .privacy-page-wrap {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .privacy-policy-information {
    padding: 15px 10px;
  }

  #privacy-policy-html ::v-deep a {
    text-decoration: underline;
  }
</style>
